export const pagesPlacesSettingsEn = {
  placeSubCodeNames: {
    addPlaceSubCodeName: 'Add Subcode Setting',
    description: 'Manage place subcode names.',
    editPlaceSubCodeName: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd: 'If not specified, defaults to 0.'
        },
        label: 'Display Order',
        placeholder: '1'
      },
      name: {
        description: 'Name must be unique within the organization.',
        label: 'Name',
        placeholder: 'Legacy Place Code'
      }
    },
    searchPlaceholder: 'Search by name',
    title: 'Subcode Settings'
  },
  shared: {
    DeleteDialog: {
      cancelButton: 'Cancel',
      description: 'If {{name}} is in use, it cannot be deleted. This action cannot be undone.',
      permanentlyDeleteButton: 'Permanently Delete',
      title: 'Delete {{name}}?'
    },
    actionsColumn: {
      deleteButton: 'Delete'
    }
  }
};